import { Link } from 'react-router-dom';
import { SOLUTIONS } from '../data/solutions';

export const LandingFooter = () => {
  return (
    <footer className="border-t border-border">
      <div className="max-w-6xl mx-auto px-6 py-14 grid sm:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/assets/images/logo.png" alt="Sistema Neurobit" className="h-8 w-auto object-contain" />
            <span className="font-extrabold tracking-tight">Sistema Neurobit</span>
          </div>
          <p className="text-sm text-muted-foreground max-w-xs">
            Gestão completa pra clínicas de saúde — agenda, prontuário, financeiro e faturamento em um só lugar.
          </p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground mb-4">Soluções</p>
          <ul className="space-y-2.5">
            {SOLUTIONS.map((s) => (
              <li key={s.slug}>
                <Link to={`/solucoes/${s.slug}`} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground mb-4">Contato</p>
          <ul className="space-y-2.5 text-sm text-muted-foreground">
            <li>
              <a href="mailto:contato@sistemaneurobit.com.br" className="hover:text-foreground transition-colors">
                contato@sistemaneurobit.com.br
              </a>
            </li>
            <li>
              <a href="https://app.sistemaneurobit.com.br" className="hover:text-foreground transition-colors">
                Acessar o sistema
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-muted-foreground">
          <span>© {new Date().getFullYear()} Sistema Neurobit. Todos os direitos reservados.</span>
          <span className="flex items-center gap-2">
            Um produto
            <img src="/assets/images/grouplogo.png" alt="Quase Um Byte" className="h-5 w-auto object-contain" />
            <span className="font-semibold text-foreground">Quase Um Byte</span>
          </span>
        </div>
      </div>
    </footer>
  );
};
